/*
 * Copyright '2022' Dell Inc. or its subsidiaries. All Rights Reserved.
 */

import {
    ITenantContextProviderConfigurator
} from "sirius-shell-support-library/tenants/configurators/tenant-context-provider-configurator.interface";
import {TenantContextProviderConfigurator} from "./configurators/tenant-context-provider.configurator";

const getTenantContextProviderConfigurator = function (): ITenantContextProviderConfigurator {
    return new TenantContextProviderConfigurator();
}

export {
    TenantContextProviderConfigurator,
    getTenantContextProviderConfigurator
}
